'use strict';

import modal from '../../modal';
import minicart from '../../minicart';

var initEvents = function() {
    $(document).on('click', 'a.product-action-compare-shades', function (e) {
        e.preventDefault();
        var urlToRender = $(this).attr('href');
        if (urlToRender) {
            modal.addCustomClass('product-compare-shades');
            modal.renderByUrl(urlToRender);
            modal.setCallback(function() {
                filterShades('swatch');
            });
        }
    });

    $(document).on('click', '.compare-shades-container .view-by a.view-by-face', function (e){    	
        if($(this).hasClass('selected')){return false;} 
        
        filterShades('face');

    }).on('click', '.compare-shades-container .view-by a.view-by-swatch', function (e){    	
        if($(this).hasClass('selected')){return false;}

        filterShades('swatch');

    }).on('click', '.compare-shades-container .view-my-skin-tone a', function (e){
        if($(this).hasClass('selected')){return false;} 

        filterShades('face', $(this).attr('id'));
    });

    $(document).on('click', '.compare-shades-actions .compare-shades-add-to-cart', function(e) {
        e.preventDefault();
        var pid = $(this).attr('data-pid');
        if(pid) {
        	var $addToBagErrorElement = $(this).closest('.compare-shades-actions.global-add-to-bag').find('.global-add-to-cart-error');
            minicart.addProduct({pid: pid},$addToBagErrorElement);
        }
    });

    $(document).on('click', '.compare-shades-actions a.compare-shades-virtual-try-on', function(e) {
        e.preventDefault();
        modal.close();
        $('#pdpMain a.product-action-virtual-try-on:first').click();
    });
    
    $(document).on('click','.compare-shades-content .compare-shades-image-tile',function(e){
    	var shadeValue = $(this).find('.product-tile-content input#compare-shades-color-value').val(); 
    	var selectedShadeValue = $('.miniproduct-info select.variation-select').val();
    	if(shadeValue != selectedShadeValue){
    		$('.miniproduct-info select.variation-select').val(shadeValue);
    		$('.miniproduct-info select.variation-select').trigger('change');
    	}
    });
}

var filterShades = function(filter1, filter2) {
    var $container = $('.compare-shades-container');

    $container.find('.view-by a').removeClass('selected');
    if(filter1 == 'face') {
        $container.find('.view-by a.view-by-face').addClass('selected');
        $container.find('.compare-shades-face-image').removeClass('hide');
        $container.find('.compare-shades-swatch-image').addClass('hide');
        
        var $viewMySkinTone = $container.find('.view-my-skin-tone');
        if($viewMySkinTone.length > 0){
        	$container.find('.view-my-skin-tone .view-my-skin-tone-header').removeClass('skintone-unselected');
        	$viewMySkinTone.removeClass('hide');	
	        var $skintones = $viewMySkinTone.find('a');
	        var $filter2 = filter2 ? $skintones.filter('#'+filter2) : $skintones.filter(':first');	        
	        $viewMySkinTone.find('a').removeClass('selected').filter($filter2).addClass('selected');
	        $container.find('.compare-shades-face-image').addClass('hide').filter('.'+$filter2.attr('id')).removeClass('hide');
        }
    } else if(filter1 == 'swatch') {
        $container.find('.view-by a.view-by-swatch').addClass('selected');

        $container.find('.compare-shades-swatch-image').removeClass('hide');
        $container.find('.compare-shades-face-image').addClass('hide');
        
        var $viewMySkinTone = $container.find('.view-my-skin-tone');
        if($viewMySkinTone.length > 0){
	        $container.find('.view-my-skin-tone a').removeClass('selected');
	        $container.find('.view-my-skin-tone .view-my-skin-tone-header').addClass('skintone-unselected');
        }
    }
}
export default function () {
    initEvents();
};
